export default __webpack_public_path__ + "static/media/baterias.c8939e5c.svg";